import { render, staticRenderFns } from "./GlobalSearchTip.vue?vue&type=template&id=7d45893e&scoped=true"
import script from "./GlobalSearchTip.vue?vue&type=script&lang=js"
export * from "./GlobalSearchTip.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchTip.vue?vue&type=style&index=0&id=7d45893e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45893e",
  null
  
)

export default component.exports